import React from 'react';
import PropTypes from 'prop-types';
import { DASHBOARD_FILTERS_NAMES } from '../../../../../../utils/constants';

import './ChartFilters.scss';
import DashboardFilter from '../../../../../../components/_molecules/DashboardFilter/DashboardFilter';

const propTypes = {
  filters: PropTypes
    .shape({})
    .isRequired,
  changeHandler: PropTypes.func.isRequired,
  campaigns: PropTypes
    .arrayOf(PropTypes.shape({}))
    .isRequired,
  users: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  userApps: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  isOverview: PropTypes.bool,
};
const defaultProps = {
  isOverview: false,
};

const platformFilters = [
  {
    label: 'All',
    value: '',
  }, {
    label: 'Facebook',
    value: 'FACEBOOK',
  }, {
    label: 'AdWords',
    value: 'ADWORDS',
  }, {
    label: 'Instagram',
    value: 'INSTAGRAM',
  }, {
    label: 'MyTarget',
    value: 'MYTARGET',
  }, {
    label: 'TikTok',
    value: 'TIKTOK',
  },
];
const parameterFilters = [
  {
    label: 'Installs',
    value: 'INSTALLS',
  },
  {
    label: 'CTR',
    value: 'CTR',
  },
  {
    label: 'Conversion',
    value: 'CONVERSION',
  },
  {
    label: 'CPI',
    value: 'CPI',
  },
  {
    label: 'Spent',
    value: 'SPENT',
  },
  {
    label: 'CPA',
    value: 'CPA',
  },
  {
    label: 'Events',
    value: 'EVENTS',
  },
];

const compareToFilters = [{
  label: 'None',
  value: '',
}, ...parameterFilters];


const ChartFilters = ({
  filters, changeHandler, campaigns, users, userApps, isOverview,
}) => {
  const platformFilter = filters[DASHBOARD_FILTERS_NAMES.PLATFORM];
  const campaignFilter = filters[DASHBOARD_FILTERS_NAMES.CAMPAIGN];
  const parameterFilter = filters[DASHBOARD_FILTERS_NAMES.PARAMETER];
  const compareFilter = filters[DASHBOARD_FILTERS_NAMES.COMPARE];
  const userFilter = filters[DASHBOARD_FILTERS_NAMES.USER];
  const appFilter = filters[DASHBOARD_FILTERS_NAMES.APP];
  return (
    <div className="chart-filters">
      {isOverview &&
      <DashboardFilter
        label="By client:"
        value={userFilter.value}
        status={userFilter.status}
        values={users}
        name={DASHBOARD_FILTERS_NAMES.USER}

        changeHandler={changeHandler}
      />
      }
      {isOverview &&
      <DashboardFilter
        label="By app:"
        value={appFilter.value}
        status={appFilter.status}
        values={userApps}
        name={DASHBOARD_FILTERS_NAMES.APP}

        changeHandler={changeHandler}
      />
      }
      <DashboardFilter
        label="By campaign:"
        values={campaigns}
        status={campaignFilter.status}
        value={campaignFilter.value}
        name={DASHBOARD_FILTERS_NAMES.CAMPAIGN}

        changeHandler={changeHandler}
      />
      <DashboardFilter
        label="By AD platform:"
        value={platformFilter.value}
        status={platformFilter.status}
        values={platformFilters}
        name={DASHBOARD_FILTERS_NAMES.PLATFORM}

        changeHandler={changeHandler}
      />
      <DashboardFilter
        label="Parameter:"
        closeOnSelect
        value={parameterFilter.value}
        values={parameterFilters}
        status={parameterFilter.status}
        name={DASHBOARD_FILTERS_NAMES.PARAMETER}
        changeHandler={changeHandler}
      />
      <DashboardFilter
        label="Compare to:"
        value={compareFilter.value}
        status={compareFilter.status}
        values={compareToFilters}
        name={DASHBOARD_FILTERS_NAMES.COMPARE}
        changeHandler={changeHandler}
      />
    </div>
  );
};

ChartFilters.propTypes = propTypes;
ChartFilters.defaultProps = defaultProps;

export default ChartFilters;



// WEBPACK FOOTER //
// ./src/containers/MainPanel/components/ChartPart/components/ChartFilters/ChartFilters.js